<template>
    <button class="trigger-standard-view" @click="$bus.$emit('setBestSellerPanel', false)"></button>
</template>

<script>
    export default {
        name: 'StandardTrigger'
    }
</script>

<style lang="scss">
    $svg-height: 410px;

    body.no-scroll {
        .trigger-standard-view {
            position: fixed;
            top: calc(#{$product-sheet-title-height} + #{$product-sheet-navigation-height} + 100px + (#{$svg-height} / 2)); // header title + header nav + margin + half svg vertical size
            opacity: 1;
        }
    }

    .trigger-standard-view {
        display: inline-block;
        position: absolute;
        top: -9999px;
        opacity: 0;
        left: -6px;
        z-index: 5;
        width: 51px;
        height: $svg-height;
        margin-top: calc(-#{$svg-height} / 2);
        background-image: url('~@/assets/img/standard-trigger.svg');
        background-repeat: no-repeat;
        cursor: pointer;
        text-indent: -9999px;
        transition: left 0.3s ease, opacity 0.5s ease 1s;

        @media #{$mq_phone} {
            display: none;
        }

        &:hover {
            left: -1px;
        }
    }
</style>
